import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import {
    UpdateCartLineApiParameter,
    updateCartLineWithResult as updateCartLineApi,
} from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

interface UpdateCartLineParameter {
    onSuccess?: () => void;
    cartLine: CartLineModel;
    shouldNotReloadPromotions?: boolean;
    shouldNotLoadFullCart?: boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartLineParameter, UpdateCartLineApiParameter>;

export const StorePopulateApiParameter: HandlerType = props => {
    // Store Custom Code - Make sure those "live" properties are not sent because they are not real and they crash the save
    /* Store Custom Code - Start */
    const propertiesToRemove = ["sku-AGI-GOI", "sku-NYBS-CT", "availabilities"];

    const updatedCartLine: CartLineModel = { ...props.parameter.cartLine };

    for (const property of propertiesToRemove) {
        if (updatedCartLine.properties[property]) {
            const { [property]: removedProperty, ...remainingProperties } = updatedCartLine.properties;
            updatedCartLine.properties = remainingProperties;
        }
    }

    const newParameter = { ...props.parameter };
    newParameter.cartLine = updatedCartLine;
    /* Store Custom Code - End */
    props.apiParameter = {
        ...newParameter,
        cartId: API_URL_CURRENT_FRAGMENT,
    };
};
replaceInChain(chain, PopulateApiParameter, StorePopulateApiParameter); // Store Custom Code
